import { useEffect } from "react";
import { f7, f7ready } from "framework7-react";
import { applyUpdate, onUpdateReady } from "../service-worker-registration";

const OPEN_MODALS =
  ".popup.modal-in, .sheet-modal.modal-in, .dialog.modal-in, .toast.modal-in";

const hasOpenModal = () => Boolean(document.querySelector(OPEN_MODALS));

const UpdatePrompt = () => {
  useEffect(() => {
    let active = true;
    let updateReady = false;
    let accepted = false;
    let toast = null;
    let stopListening = () => {};

    const showWhenNothingIsOpen = () => {
      if (!active || !updateReady || accepted || toast || hasOpenModal()) {
        return;
      }
      toast = f7.toast.create({
        text: "Neue Version verfügbar",
        closeButton: true,
        closeButtonText: "Aktualisieren",
        cssClass: "update-toast",
        destroyOnClose: true,
        on: {
          closeButtonClick: () => {
            accepted = true;
            applyUpdate();
          },
          closed: () => {
            toast = null;
          },
        },
      });
      toast.open();
    };

    f7ready(() => {
      if (!active) return;
      f7.on("modalClosed", showWhenNothingIsOpen);
      const unsubscribe = onUpdateReady(() => {
        updateReady = true;
        showWhenNothingIsOpen();
      });
      stopListening = () => {
        unsubscribe();
        f7.off("modalClosed", showWhenNothingIsOpen);
      };
    });

    return () => {
      active = false;
      stopListening();
      toast?.close();
    };
  }, []);

  return null;
};

export default UpdatePrompt;
